module.exports = __webpack_public_path__ + "img/UTANAS-6.9e9f845d.jpg";